import { useAuth } from "@pma/stores/auth-store"
import { ADMIN_ROLE_ID } from "@pma/utils/constants"

interface OrgRole {
  id: number
  name: string
}

interface UserOrganization {
  id: number
  name?: string
  company_name?: string
  role?: OrgRole
}

export function usePermissions() {
  const { authConfig } = useAuth()

  const organization_id = authConfig?.last_organization_id

  const currentOrg = authConfig?.companies_of_user?.find(
    (org: UserOrganization) => org.id === organization_id,
  )

  const isOrgAdmin = currentOrg?.role?.id === ADMIN_ROLE_ID

  return {
    isOrgAdmin,
    currentOrg,
    organization_id,
    hasOrgAccess: !!currentOrg,
  }
}
